import React from "react";
import useScreenResolution from "../../../hooks/useScreenResolution";

const shimmer =
  "relative overflow-hidden bg-[#EEF2F4] before:absolute before:inset-0 before:-translate-x-full before:animate-[faqShimmer_1.4s_infinite] before:bg-gradient-to-r before:from-transparent before:via-white/60 before:to-transparent";

const Bar = ({ className = "" }) => (
  <span className={`block rounded-md ${shimmer} ${className}`} />
);

const HighlightCardSkeleton = () => (
  <div
    className="w-[310px] p-6 bg-[#F6F8F9] rounded-[16px] flex-shrink-0"
    style={{ display: "inline-block", marginRight: "5px" }}
  >
    <Bar className="h-4 w-3/4 mb-3" />
    <Bar className="h-3 w-full mb-2" />
    <Bar className="h-3 w-5/6 mb-2" />
    <Bar className="h-3 w-2/3" />
  </div>
);

const TabSkeleton = ({ width = "w-24" }) => (
  <Bar className={`h-8 ${width} rounded-full`} />
);

const AccordionRowSkeleton = ({ width = "w-2/3" }) => (
  <li className="faq-box border bg-white rounded-[10px] border-solid border-[#DDE2E4] list-none px-6 py-4 mb-2">
    <div className="flex justify-between items-center">
      <Bar className={`h-4 ${width}`} />
      <Bar className="h-8 w-8 rounded-full" />
    </div>
  </li>
);

const FaqSkeleton = () => {
  const screenResolution = useScreenResolution();
  const isMobile = screenResolution.mobile;

  return (
    <>
      <style>{`@keyframes faqShimmer { 100% { transform: translateX(100%); } }`}</style>

      <section className="ipad:p-4 mt-0 max767:flex-col max767:mt-[30%]">
        {!isMobile ? (
          <div className="p-6">
            <div className="flex justify-between mt-0 w-full">
              <Bar className="h-7 w-32" />
              <div className="arrowbutn flex gap-2">
                <Bar className="h-[36px] w-[36px] rounded-full" />
                <Bar className="h-[36px] w-[36px] rounded-full" />
              </div>
            </div>
          </div>
        ) : (
          <div className="mb-6 max767:pl-5">
            <Bar className="h-7 w-48" />
          </div>
        )}

        <div
          className="flex overflow-x-hidden space-x-0 pl-5 pr-0 py-0 max767:mt-[5%] max767:pl-5 rtl:pr-5 rtl:pl-0"
          style={{ display: "flex", whiteSpace: "nowrap" }}
        >
          {[0, 1, 2, 3].map((i) => (
            <HighlightCardSkeleton key={i} />
          ))}
        </div>
      </section>

      <div className="p-6 pt-0 pb-0 max767:p-0">
        <section className="mt-8 ipad:p-4">
          <div className="flex gap-3 max767:px-5 max767:overflow-x-hidden">
            <TabSkeleton width="w-20" />
            <TabSkeleton width="w-28" />
            <TabSkeleton width="w-24" />
            <TabSkeleton width="w-32" />
          </div>

          <ul className="faq-list mt-6 w-[700px] max-w-[100%] max767:p-5 max767:mt-1">
            <AccordionRowSkeleton width="w-3/4" />
            <AccordionRowSkeleton width="w-2/3" />
            <AccordionRowSkeleton width="w-4/5" />
            <AccordionRowSkeleton width="w-1/2" />
            <AccordionRowSkeleton width="w-3/4" />
            <AccordionRowSkeleton width="w-2/3" />
          </ul>
        </section>
      </div>
    </>
  );
};

export default FaqSkeleton;
